// import { memo, useState } from "react";
// import { motion } from "framer-motion";

// const GRADIENT_TEXT =
//   "bg-gradient-to-r from-blue-400 to-pink-400 bg-clip-text text-transparent";

// const TickerHoverText = ({
//   label = "Login now to step inside — your data has more to reveal than meets the eye.",
//   tickerText = "Login now to step inside — your data has more to reveal than meets the eye.",
//   className = "",
// }) => {
//   const [hovered, setHovered] = useState(false);

//   return (
//     <span
//       onMouseEnter={() => setHovered(true)}
//       onMouseLeave={() => setHovered(false)}
//       className={`relative inline-block overflow-hidden cursor-pointer ${className}`}
//     >
//       {/* Static */}
//       <motion.span
//         animate={{ opacity: hovered ? 0 : 1 }}
//         transition={{ duration: 0.15 }}
//         className={`block ${GRADIENT_TEXT}`}
//       >
//         {label}
//       </motion.span>

//       {/* Ticker */}
//       {hovered && (
//         <motion.span
//           className="absolute inset-0 flex items-center whitespace-nowrap"
//           initial={{ opacity: 0 }}
//           animate={{ opacity: 1 }}
//         >
//           <motion.span
//             animate={{ x: ["0%", "-50%"] }}
//             transition={{ repeat: Infinity, duration: 6, ease: "linear" }}
//             className={`flex gap-6 ${GRADIENT_TEXT}`}
//           >
//             <span>{tickerText}</span>
//             <span>{tickerText}</span>
//           </motion.span>
//         </motion.span>
//       )}
//     </span>
//   );
// };

// export default memo(TickerHoverText);
// import { useEffect, useState } from "react";
// import { motion, AnimatePresence } from "framer-motion";

// const TypingText = ({
//   words = [],
//   typingSpeed = 120,
//   deletingSpeed = 80,
//   pauseTime = 1200,
// }) => {
//   const [wordIndex, setWordIndex] = useState(0);
//   const [charIndex, setCharIndex] = useState(0);
//   const [isDeleting, setIsDeleting] = useState(false);

//   useEffect(() => {
//     const currentWord = words[wordIndex];

//     let timeout;

//     if (!isDeleting && charIndex < currentWord.length) {
//       timeout = setTimeout(
//         () => setCharIndex((prev) => prev + 1),
//         typingSpeed
//       );
//     } else if (isDeleting && charIndex > 0) {
//       timeout = setTimeout(
//         () => setCharIndex((prev) => prev - 1),
//         deletingSpeed
//       );
//     } else if (!isDeleting && charIndex === currentWord.length) {
//       timeout = setTimeout(() => setIsDeleting(true), pauseTime);
//     } else if (isDeleting && charIndex === 0) {
//       setIsDeleting(false);
//       setWordIndex((prev) => (prev + 1) % words.length);
//     }

//     return () => clearTimeout(timeout);
//   }, [charIndex, isDeleting, wordIndex, words, typingSpeed, deletingSpeed, pauseTime]);

//   return (
//     <div className="mt-4 text-4xl md:text-5xl font-extrabold flex justify-center">
//       <AnimatePresence mode="wait">
//         <motion.span
//           key={wordIndex}
//           initial={{ opacity: 0 }}
//           animate={{ opacity: 1 }}
//           exit={{ opacity: 0 }}
//           className="bg-gradient-to-r from-purple-400 to-pink-500 bg-clip-text text-transparent"
//         >
//           {words[wordIndex].slice(0, charIndex)}
//           <span className="ml-1 animate-pulse">|</span>
//         </motion.span>
//       </AnimatePresence>
//     </div>
//   );
// };

// export default TypingText;
import { useEffect, useState } from "react";

const TypingSentence = ({
  text,
  typingSpeed = 70,
  deletingSpeed = 40,
  pauseTime = 1800,
}) => {
  const [index, setIndex] = useState(0);
  const [isDeleting, setIsDeleting] = useState(false);

  useEffect(() => {
    let timeout;

    if (!isDeleting && index < text.length) {
      timeout = setTimeout(() => setIndex((prev) => prev + 1), typingSpeed);
    } else if (isDeleting && index > 0) {
      timeout = setTimeout(() => setIndex((prev) => prev - 1), deletingSpeed);
    } else if (!isDeleting && index === text.length) {
      timeout = setTimeout(() => setIsDeleting(true), pauseTime);
    } else if (isDeleting && index === 0) {
      setIsDeleting(false);
    }

    return () => clearTimeout(timeout);
  }, [index, isDeleting, text, typingSpeed, deletingSpeed, pauseTime]);

  return (
    <div className="mt-4 text-3xl md:text-3xl font-extrabold text-center">
      <span className="bg-gradient-to-r from-purple-400 to-pink-500 bg-clip-text text-transparent">
        {text.slice(0, index)}
      </span>
      <span className="ml-1 animate-pulse text-pink-400">|</span>
    </div>
  );
};

export default TypingSentence;

